import { Component } from '@angular/core';
import { ITooltipConfig, TooltipDirective, TooltipPosition } from '@ra-web-tech-ui-toolkit/components';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-ag-credits-activity',
  templateUrl: './ag-credits-activity.component.html',
  styleUrls: [],
  imports: [TooltipDirective],
})
export class AgTokensActivityComponent implements ICellRendererAngularComp {
  readonly tooltipConfig: ITooltipConfig = { position: TooltipPosition.Right, tooltipClass: 'tooltip-ledger' };
  tokenActivity: string;
  discountDetailsTooltip: string;

  refresh(): boolean {
    return false;
  }

  agInit(params: any): void {
    this.tokenActivity = params.mapTokenConsumption(params);
    this.discountDetailsTooltip = params.generateDiscountTooltip(params);
  }
}
